import type { ReactNode } from 'react';
import { ThemeProvider } from 'styled-components';
import { defaultTheme } from './defaultTheme';

export const DefaultTheme = ({ children }: { children: ReactNode }) => {
  return <ThemeProvider theme={defaultTheme}>{children}</ThemeProvider>;
};
